import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../shared/api.service';

export interface Provider {
    id?: number;
    business_name: string;
    trade_name?: string | null;
    provider_type?: string | null;
    rfc: string;
    email?: string | null;
    phone?: string | null;
    fiscal_address?: string | null;
    city?: string | null;
    bank_name?: string | null;
    beneficiary_name?: string | null;
    account_number?: string | null;
    clabe?: string | null;
    account_type?: string | null;
}

@Injectable({
    providedIn: 'root'
})
export class ProviderService {
    private endpoint = 'providers';

    constructor(private apiService: ApiService) { }

    listProviders(): Observable<any> {
        return this.apiService.get(`${this.endpoint}/list`);
    }

    getProvider(id: number): Observable<any> {
        return this.apiService.get(`${this.endpoint}/show/${id}`);
    }

    addProvider(data: Provider): Observable<any> {
        return this.apiService.post(`${this.endpoint}/add`, data);
    }

    updateProvider(id: number, data: Provider): Observable<any> {
        return this.apiService.post(`${this.endpoint}/update/${id}`, data);
    }

    deleteProvider(id: number): Observable<any> {
        return this.apiService.get(`${this.endpoint}/delete/${id}`);
    }

    getMonthlySummary(period: string): Observable<any> {
        return this.apiService.get(`provider-payments/monthly-summary?period=${period}`);
    }

    getMonthlyPayments(params: { period: string; status?: string; search?: string; page?: number; per_page?: number }): Observable<any> {
        const query = new URLSearchParams();
        query.set('period', params.period);
        if (params.status) query.set('status', params.status);
        if (params.search) query.set('search', params.search);
        query.set('page', String(params.page ?? 1));
        query.set('per_page', String(params.per_page ?? 6));
        return this.apiService.get(`provider-payments/monthly?${query.toString()}`);
    }

    getPaymentDetail(id: number): Observable<any> {
        return this.apiService.get(`provider-payments/${id}`);
    }

    uploadPaymentInvoice(id: number, file: File): Observable<any> {
        const formData = new FormData();
        formData.append('invoice', file);
        return this.apiService.post(`provider-payments/${id}/invoice`, formData);
    }

    authorizePayment(id: number): Observable<any> {
        return this.apiService.post(`provider-payments/${id}/authorize`, {});
    }

    registerPayment(id: number, comprobante: File): Observable<any> {
        const formData = new FormData();
        formData.append('comprobante', comprobante);
        return this.apiService.post(`provider-payments/${id}/pay`, formData);
    }

    updateInvoiceDetails(id: number, data: { invoice_number: string | null; invoice_date: string | null }): Observable<any> {
        return this.apiService.post(`provider-payments/${id}/invoice-details`, data);
    }

    deleteInvoice(id: number): Observable<any> {
        return this.apiService.post(`provider-payments/${id}/invoice/delete`, {});
    }
}
